var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChopModel_instances, _ChopModel_boundaries, _ChopModel_set, _ChopModel_setCapped;
import { clamp } from "@opendaw/lib-std";
export const GridDivisions = [1 / 4, 1 / 8, 1 / 16, 1 / 32];
export var ChopMath;
(function (ChopMath) {
    ChopMath.MAX_KEY = 128;
    ChopMath.fitBpmPow2 = (durationInSeconds) => {
        if (durationInSeconds <= 0.0) {
            return 120;
        }
        let bpm = 60 / durationInSeconds;
        while (bpm < 90) {
            bpm *= 2;
        }
        while (bpm > 180) {
            bpm /= 2;
        }
        return bpm;
    };
    ChopMath.sliceSecondsForGrid = (bpm, division) => (60 / bpm) * (4 * division);
})(ChopMath || (ChopMath = {}));
export class ChopModel {
    constructor() {
        _ChopModel_instances.add(this);
        _ChopModel_boundaries.set(this, [0.0, 1.0]);
    }
    get boundaries() { return __classPrivateFieldGet(this, _ChopModel_boundaries, "f"); }
    fromTransients(transientSeconds, durationInSeconds, maxSlices) {
        if (durationInSeconds <= 0.0) {
            __classPrivateFieldGet(this, _ChopModel_instances, "m", _ChopModel_set).call(this, [0.0, 1.0]);
            return;
        }
        __classPrivateFieldGet(this, _ChopModel_instances, "m", _ChopModel_setCapped).call(this, transientSeconds.map(seconds => seconds / durationInSeconds), maxSlices);
    }
    fromGrid(bpm, division, durationInSeconds, maxSlices) {
        if (durationInSeconds <= 0.0 || bpm <= 0.0) {
            __classPrivateFieldGet(this, _ChopModel_instances, "m", _ChopModel_set).call(this, [0.0, 1.0]);
            return;
        }
        const sliceSeconds = ChopMath.sliceSecondsForGrid(bpm, division);
        if (sliceSeconds <= 0.0) {
            __classPrivateFieldGet(this, _ChopModel_instances, "m", _ChopModel_set).call(this, [0.0, 1.0]);
            return;
        }
        const boundaries = [];
        for (let seconds = 0.0; seconds < durationInSeconds; seconds += sliceSeconds) {
            boundaries.push(seconds / durationInSeconds);
        }
        boundaries.push(1.0);
        __classPrivateFieldGet(this, _ChopModel_instances, "m", _ChopModel_setCapped).call(this, boundaries, maxSlices);
    }
    dragBoundary(index, position) {
        if (index <= 0 || index >= __classPrivateFieldGet(this, _ChopModel_boundaries, "f").length - 1) {
            return;
        }
        const lower = __classPrivateFieldGet(this, _ChopModel_boundaries, "f")[index - 1];
        const upper = __classPrivateFieldGet(this, _ChopModel_boundaries, "f")[index + 1];
        __classPrivateFieldGet(this, _ChopModel_boundaries, "f")[index] = clamp(position, lower, upper);
    }
    splitAt(position) {
        const value = clamp(position, 0.0, 1.0);
        if (value <= 0.0 || value >= 1.0) {
            return;
        }
        const insertIndex = __classPrivateFieldGet(this, _ChopModel_boundaries, "f").findIndex(boundary => boundary > value);
        if (insertIndex <= 0) {
            return;
        }
        if (__classPrivateFieldGet(this, _ChopModel_boundaries, "f")[insertIndex - 1] === value) {
            return;
        }
        __classPrivateFieldGet(this, _ChopModel_boundaries, "f").splice(insertIndex, 0, value);
    }
    removeBoundary(index) {
        if (index <= 0 || index >= __classPrivateFieldGet(this, _ChopModel_boundaries, "f").length - 1) {
            return;
        }
        __classPrivateFieldGet(this, _ChopModel_boundaries, "f").splice(index, 1);
    }
    slices(startKey) {
        const count = Math.min(__classPrivateFieldGet(this, _ChopModel_boundaries, "f").length - 1, ChopMath.MAX_KEY - startKey);
        const slices = [];
        for (let index = 0; index < count; index++) {
            slices.push({ start: __classPrivateFieldGet(this, _ChopModel_boundaries, "f")[index], end: __classPrivateFieldGet(this, _ChopModel_boundaries, "f")[index + 1] });
        }
        return slices;
    }
}
_ChopModel_boundaries = new WeakMap(), _ChopModel_instances = new WeakSet(), _ChopModel_set = function _ChopModel_set(normalized) {
    const sorted = Array.from(new Set(normalized.map(value => clamp(value, 0.0, 1.0)))).sort((a, b) => a - b);
    if (sorted.length === 0 || sorted[0] > 0.0) {
        sorted.unshift(0.0);
    }
    if (sorted.length < 2) {
        sorted.push(1.0);
    }
    __classPrivateFieldGet(this, _ChopModel_boundaries, "f").length = 0;
    __classPrivateFieldGet(this, _ChopModel_boundaries, "f").push(...sorted);
}, _ChopModel_setCapped = function _ChopModel_setCapped(normalized, maxSlices) {
    __classPrivateFieldGet(this, _ChopModel_instances, "m", _ChopModel_set).call(this, normalized);
    if (maxSlices > 0 && __classPrivateFieldGet(this, _ChopModel_boundaries, "f").length - 1 > maxSlices) {
        __classPrivateFieldGet(this, _ChopModel_boundaries, "f").length = maxSlices + 1;
    }
};
